import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'og-notice-banner',
  standalone: true,
  templateUrl: './notice-banner.component.html',
  styleUrls: ['./notice-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticeBannerComponent {
  @Input() theme: 'warning' | 'information' = 'warning';
  @Input() dismissLabel = 'Dismiss subscription expiration warning';
  @Output() dismiss = new EventEmitter<void>();
}
